export var getCapitalFirstLetter = function (value) { return value.charAt(0).toUpperCase(); };
